"use client";

import React from "react";
import { cn } from "@/utils/utils";

export type BadgeColor = "red" | "blue" | "green" | "purple" | "gray";

interface RemovableBadgeProps {
  label: string;
  onRemove?: () => void;
  color?: BadgeColor;
  className?: string;
}

const getColorStyles = (color: BadgeColor) => {
  switch (color) {
    case "red":
      return {
        badge: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
        button:
          "text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-200",
      };
    case "blue":
      return {
        badge:
          "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300",
        button:
          "text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-200",
      };
    case "green":
      return {
        badge:
          "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300",
        button:
          "text-green-600 hover:text-green-800 dark:text-green-400 dark:hover:text-green-200",
      };
    case "purple":
      return {
        badge:
          "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300",
        button:
          "text-purple-600 hover:text-purple-800 dark:text-purple-400 dark:hover:text-purple-200",
      };
    default:
      return {
        badge: "bg-gray-100 text-gray-800 dark:bg-slate-700 dark:text-gray-300",
        button:
          "text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200",
      };
  }
};

export function RemovableBadge({
  label,
  onRemove,
  color = "gray",
  className,
}: RemovableBadgeProps) {
  const styles = getColorStyles(color);

  return (
    <span
      className={cn(
        "px-3 py-1 rounded-full text-sm flex items-center gap-1",
        styles.badge,
        className,
      )}
    >
      {label}
      {onRemove && (
        <button
          aria-label={`Remove ${label}`}
          className={cn("ml-1", styles.button)}
          onClick={onRemove}
          type="button"
        >
          ×
        </button>
      )}
    </span>
  );
}
